import React from "react";
import { FaBullseye, FaEye, FaHandshake } from "react-icons/fa";
import "./MissionVision.css";

function MissionVision() {
  const items = [
    {
      icon: <FaBullseye />,
      title: "Our Mission",
      description:
        "To provide fast, reliable, and affordable mobile repair services directly at our customers' locations across the UAE.",
      animation: "fade-right",
    },
    {
      icon: <FaEye />,
      title: "Our Vision",
      description:
        "To become the most trusted and convenient doorstep mobile repair service provider in the UAE.",
      animation: "fade-up",
    },
    {
      icon: <FaHandshake />,
      title: "Our Values",
      description:
        "Quality workmanship, transparency, customer satisfaction, and professionalism in every repair we perform.",
      animation: "fade-left",
    },
  ];

  return (
    <section className="mission-vision-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">Our Purpose</span>

          <h2 className="section-title">Mission, Vision & Values</h2>

          <p className="section-description">
            Everything we do is guided by our commitment to quality,
            convenience, and customer satisfaction.
          </p>
        </div>

        <div className="row">
          {items.map((item, index) => (
            <div
              className="col-lg-4 col-md-6 col-12 mb-3"
              key={index}
              data-aos={item.animation}
              data-aos-delay={index * 150}
            >
              <div className="mv-card">
                <div className="mv-icon">{item.icon}</div>

                <h4>{item.title}</h4>

                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MissionVision;
